import { create } from "zustand";

interface HookProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  leadId: string;
  setLeadId: (id: string) => void;
}

export const useViewLeadLogs = create<HookProps>()((set) => ({
  leadId: "",
  setLeadId: (id) =>
    set(() => ({
      leadId: id,
    })),

  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
